import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleCategoryClick = useCallback(
    (slug: string) => {
      navigate(`/category/${slug}`);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    [navigate],
  );

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
            title="17c·moc起草糖心在线看"
          >
            <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-play-circle-fill text-white text-lg" style={{ width: '20px', height: '20px' }}></i>
            </div>
            <span className={`font-heading font-bold text-lg transition-colors ${isScrolled ? 'text-foreground-900' : 'text-white'}`}>
              糖心在线看
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? isScrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : isScrolled
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap cursor-pointer transition-colors ${
                isScrolled
                  ? 'text-foreground-600 hover:text-foreground-900'
                  : 'text-white/80 hover:text-white'
              } ${location.pathname === '/about' ? (isScrolled ? 'text-primary-600 font-medium' : 'text-white font-medium') : ''}`}
            >
              关于我们
            </Link>
            <button
              type="button"
              className={`ml-2 px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'hover:bg-primary-600' : 'hover:bg-primary-400'
              }`}
            >
              立即观看
            </button>
          </div>

          <button
            type="button"
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl transition-colors ${isScrolled ? 'text-foreground-900' : 'text-white'}`}
              style={{ width: '24px', height: '24px' }}
            >
              {isMobileMenuOpen ? '✕' : '☰'}
            </i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-background-200 shadow-lg">
          <div className="container-custom py-4">
            <div className="grid grid-cols-3 gap-2 mb-4">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => handleCategoryClick(cat.slug)}
                  className={`flex flex-col items-center gap-1 p-3 rounded-lg text-center cursor-pointer transition-colors ${
                    location.pathname.includes(`/category/${cat.slug}`)
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className={`${cat.icon} text-lg`} style={{ width: '20px', height: '20px' }}></i>
                  </div>
                  <span className="text-xs whitespace-nowrap">{cat.name}</span>
                </button>
              ))}
            </div>
            <Link
              to="/about"
              className="block w-full py-3 text-center text-sm text-foreground-700 hover:text-foreground-900 bg-background-100 rounded-lg cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}